import React, { useEffect, useState } from "react";
import BSpinner from "../../components/spinners/BSpinner";
import { usersService } from "../../service/usersService";
import { useHistory } from "react-router";
import { useParams } from "react-router";
import NotesForm from "./NotesForm";

export default function UserNotesPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [user, setUser] = useState({});
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);

    usersService
      .getUserById(id)
      .then((res) => { 
        setUser(res.data);
      })
      .catch((err) => {
        if (err.response.data) {
          setErrors(err.response.data);
        }
      })
      .finally(() => setIsLoading(false));
  }, [id]);

  const tryUpdate = (data) => {
    setIsLoading(true);
    setErrors([])

    usersService
      .updateUserNotes(id, data.note)
      .then(() => {
        history.push(`/users/${id}`);
      })
      .catch((err) => {
        if (err.response.data) {
          setErrors(err.response.data);
        }
      })
      .finally((_) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading && <BSpinner />}
      {!isLoading && (
        <div className="m-6 bg-white border-gray-400 rounded shadow-md relative">
          <NotesForm
            onSubmit={tryUpdate}
            isNew={false}
            preloadedData={user}
            btnText="Speichern"
            responseErrors={errors}
          />
        </div>
      )}
    </>
  );
}